<template src="./login.html" />

<script>
import {
  PbAlert,
  PbButton,
} from 'vue-polar-bear';

import PromiseCall from '@/objects/PromiseCall';
import validator from '../../mixins/utils/validator';

export default {
  name: 'Login',
  components: {
    PbAlert,
    PbButton,
  },
  mixins: [validator],
  data() {
    return {
      portal: this.$portal,
      company: this.$company,

      email: this.$user.email,
      password: '',
      name: this.$user.name,
      confirmedEmail: null,
      validatedEmail: false,
      selfRegistration: {
        enabled: true,
        enableUserNotRegisteredNotification: false,
      },

      show: {
        showAlert: false,
      },

      ldapAlertText: '',

      isLdapUser: false,

      messageHtml: '',

      call: new PromiseCall(),
    };
  },
  computed: {
    hasExternalAuth() {
      return this.company.json.hasExternalAuth;
    },
    hasAdfsAuth() {
      return !!this.company.json.adfsConfig;
    },
    showHelpButton() {
      return this.company.json.showHelpButton;
    },
    hasPublicModules() {
      if (
        this.company.json.module.find(
          i => _.get(i, 'role.showLogin') === true
            || _.get(i, 'role.showLogin') === 'true',
        )
      )
        return true;
      return false;
    },
    toggleContainerType() {
      if (this.hasPublicModules) return 'container';
      return 'container-500';
    },
    confirmEmailOptions() {
      const didYouMean = this.$emailValidator.validate(this.email);
      const confirmOption = {
        htmlLabel: `
          <span style="color: var(--color-primary-light);">
            <p style="color: var(--color-primary)" class="pb-strong" text-transform: uppercase; font-weight: 500; margin: 3px 0px">${this.email}</p>
          </span>
        `,
        value: this.email,
      };

      if (didYouMean !== null && didYouMean !== this.email) {
        const [name, domain] = didYouMean.split('@');
        return [
          confirmOption,
          {
            htmlLabel: `
              <span style="color: #3c4858;">
                <p style="color: var(--color-primary)" class="pb-strong" style="text-transform: uppercase; font-weight: 500; margin: 3px 0px">
                  ${name}@<span style="text-decoration: underline;">${domain}</span>
                </p>
                </span>
            `,
            value: didYouMean,
            isCorrect: true,
          },
        ];
      }
      return [confirmOption];
    },
    messageResponsiveEmbed() {
      if (_.get(this.company, 'json.message.login.responsiveEmbed') == true) return true;
      return false;
    },

  },
  mounted() {
    this.getMessage();
    this.openModalLogin();
    this.getSelfRegistration();

    const openChatOnLogin = _.get(this.company.json, 'chat.openOnLogin');
    if (openChatOnLogin) this.$brain.openChat();

    brain.portal.isLoaded = true;
  },
  methods: {
    /**
     * FN TO CHECK EMAIL FORM
     */
    checkEmail() {
      this.email = this.email.toLowerCase();

      if (
        !_.isUndefined(this.$refs.formLoginEmail)
        && !this.$refs.formLoginEmail.isValid()
      )
        return;
      this.call.run(
        this.$utils.authCore.userExists(this.email),
        this.checkEmailSuccess,
        this.checkEmailFail,
      );
    },
    async checkEmailSuccess(res) {
      this.isAdfsUser = res.data.isAdfs;
      if (this.isAdfsUser)
        await this.getAdfsProviderAuthentication();

      if (res.data.blocked || res.data.hostBlocked) return this.userBlocked();

      if (!res.data.nick || res.data.status === 'pendingByDirectHash') {
        if (!this.selfRegistration.enabled && this.selfRegistration.enableUserNotRegisteredNotification)
          return this.invalidEmail();
        if (!this.validatedEmail) return this.showConfirmEmailModal();


        return this.createNewUser();
      }

      this.isLdapUser = res.data.isLdap;

      this.name = this.$user.getFirstNick(res.data.nick);
    },
    checkEmailFail(err) {
      return this.$brain.connectionError({
        code: 'checkEmailFail',
        data: {
          email: this.email,
        },
        stack: _.get(err, 'stack') || _.get(err, 'message') || err,
      });
    },

    /**
     * FN TO CONFIRM EMAIL
     */
    async showConfirmEmailModal() {
      this.confirmedEmail = null;
      try {
        await brain.swal({
          html: `
            <style>
              .email-possibilities { text-transform: none !important; font-size: 13px !important; border: 0px; font-weight: 100; background-color: #eee; text-align: center; padding: 10px; margin: 5px; border-radius: 6px; transition: .2s }
              .email-possibilities:hover { background-color: #dcdcdc !important }
            </style>
           <div style="padding: 10px">
             <div>
              <h3 class="pb">O seu e-mail está correto?</h3>
              <p class="pb margin-top-20" >Identificamos um formato de e-mail fora do padrão e por isso gostaríamos de confirmar o e-mail correto.</p>
            </div>
          ${this.confirmEmailOptions.length > 1 ? `
             <div class="margin-top-20; margin-bottom-20">
              <div style="padding-top: 50px; display: flex;">
                <p class="pb-strong">Clique na opção correta para continuar:</p>
              </div>
              <div class="p-flex">
                <small class="p-flex p-flex-column" style="width: 100%">
                  ${this.confirmEmailOptions.map(option => `
                    <button
                      class="email-possibilities cursor-pointer possibility-value"
                      value="${option.value}"
                    >
                      <div style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
                        ${option.htmlLabel}
                        <i style="color: var(--color-primary)" class="fa-regular fa-circle-right"></i>
                      </div>
                    </button>
                  `).join('')}
                  <button id="swal-close-modal" style=" background: none; border: none; padding: 0; text-decoration: underline; color: var(--color-primary); padding-top: 25px;" class="cursor-pointer">
                    <p style="margin: 1px 0 !important">Quero digitar meu e-mail novamente!</p>
                  </button>
                </small>
              </div>
              <div id="email-error" style="display: none">
                <div class="p-flex p-content-center p-align-center padding-10">
                  <pb-icon class="fas fa-exclamation-circle" style="color: #d06361; margin: 0 10px"></pb-icon>
                  <p style="color: #d06361; margin: 0 !important">Este e-mail não é válido, por favor, tente outro e-mail!</p>
                </div>
              </div>
            </div>
          ` : `
            ${this.confirmEmailOptions.map(option => `
             <div style="display: flex; flex-direction: column; justify-content: center;">
               <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                <i style="color: var(--color-primary)" class="fa-regular fa-envelope"></i>
                <p class="pb" style="padding-right: 10px;"> ${option.htmlLabel}</p>
              </div>
             <div style="display: flex; justify-content: center;">
               <button
                class="cursor-pointer possibility-value"
                style="background-color: var(--color-primary); color: white; border: none; padding: 15px; border-radius: 6px; margin-top: 10px; width: 50%; margin-top: 15px;"
                value="${option.value}"
              >
                Sim, esta correto
              </button>
             </div>
            `).join('')}
            <button id="swal-close-modal" style=" background: none; border: none; padding: 0; text-decoration: underline; color: var(--color-primary); padding-top: 25px;" class="cursor-pointer">
              <p style="margin: 1px 0 !important">Prefiro digitar novamente</p>
            </button>
            </div>
          `}
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
           </div>
          `,
          showCancelButton: false,
          showConfirmButton: false,
          cancelButtonText: 'Voltar',
          width: 430,
          onOpen: () => {
            $('.possibility-value').click(el => {
              if (this.isEmail(el.currentTarget.value) !== '') return $('#email-error').css('display', 'block');

              this.confirmedEmail = el.currentTarget.value;
              this.call.run(this.validateEmail(this.confirmedEmail));
              brain.swalClose();
            });

            $('#swal-close-modal').click(() => {
              brain.proSwal.cancel();
            });
          },
        });
      } catch (err) {
        this.$refs['input-email'].focus();
      }
    },

    validateEmail(email) {
      return new Promise((resolve, reject) => {
        if (this.email !== email) {
          this.email = email;
          this.validatedEmail = true;
          return this.checkEmail();
        }

        return this.createNewUser();
      });
    },

    /**
     * FN TO LOGIN FORM
     */
    login() {
      if ((!this.hasExternalAuth) && (!this.$refs.formLoginPassword.isValid())) return;
      if ((this.hasExternalAuth) && (!this.$refs.formLoginEmail.isValid())) return;
      if ((!this.hasExternalAuth) && (!this.name)) {
        this.invalidPassword();
        return;
      }
      this.call.run(
        this.$utils.authCore.login(this.email, this.password),
        this.loginSuccess,
        this.loginFail,
      );
    },

    help() {
      this.$brain.redirectToRoute('/help');
    },

    async getAdfsProviderAuthentication() {
      try {
        this.call.setPending();
        const response = await this.$utils.authCore.getAdfsProviderAuthentication(this.company.json.id);
        window.open(response.url, '_self');
        this.call.setResolved();
      } catch (e) {
        this.call.setRejected();
      }
    },

    async loginSuccess(res) {
      this.$user.loadFromLogin(res.user, res.code, null, false, false);

      const redirectToTermsRoute = () => {
        this.$cookies.set('code', res.code);
        localStorage.setItem('code', btoa(res.code));
        this.$brain.openChat();
        this.storeNavigatorCredentials();
        this.$brain.redirectToRoute(brain.user.getTermUrl(res.user));
      };

      const makeLogin = () => {
        this.$user.loadFromLogin(res.user, res.code);
        this.$cookies.set('code', res.code);
        localStorage.setItem('code', btoa(res.code));
        this.$user.isLdapUser = this.isLdapUser;
        this.$brain.openChat();
        this.storeNavigatorCredentials();
        
        if (this.$route.query.redirect_url) this.$brain.redirectToRoute(this.$route.query.redirect_url);
        else if (brain.utils.hasToAcceptNotifications()) brain.redirectToRoute('/notifications', { isLoggingIn: true });
        else this.$brain.sendToAppRoute(true);
      };

      const showError = () => {
        brain.swal({
          title: 'Estamos em manutenção',
          type: 'info',
          html: _.get(this.company.json.loginConnectionCheck, 'errorText') || '',
        });
      };

      if (_.get(this.company.json.loginConnectionCheck, 'forceConnectionError')) {
        showError();
        return;
      }

      if (
        _.get(this.company.json.loginConnectionCheck, 'enable')
        && _.get(this.company.json.loginConnectionCheck, 'sql')
        && _.get(this.company.json.loginConnectionCheck, 'connector')
      ) {
        return this.call.run(
          brain.utils.remoteSqlCore.executeSql({
            sql: this.company.json.loginConnectionCheck.sql,
            connector: this.company.json.loginConnectionCheck.connector,
            timeout: 7000,
          }), () => {
            makeLogin();
          }, err => {
            this.$brain.connectionError(this.company.json.loginConnectionCheck.errorText, false);
            showError();
            this.$user.logout();
          },
        );
      }

      if (res.user.pendingTerms && Object.keys(res.user.pendingTerms).length) {
        this.$set(this.$user, 'pendingTerms', true);
        return redirectToTermsRoute();
      }

      return makeLogin();
    },

    loginFail(err) {
      if (this.hasExternalAuth && (err.status === 400))
        return this.invalidUsernameOrPassword(err.responseJSON.error);

      if (err.status == 401) return this.invalidPassword();
      if (err.status === 400 && _.get(err, 'responseJSON.error') === 'Usuário bloqueado') return this.userBlocked();
      return this.$brain.connectionError({
        code: 'loginFail',
        data: {
          email: this.email,
          password: this.password,
        },
        stack: _.get(err, 'stack') || _.get(err, 'message') || err,
      });
    },
    storeNavigatorCredentials() {
      if (!_.get(navigator, 'credentials') || !_.get(window, 'PasswordCredential')) return;
      navigator.credentials.store(
        new PasswordCredential({ id: this.email, password: this.password }),
      );
    },

    ldapMessage() {
      this.ldapAlertText = `Seu e-mail é autenticado no domínio ${this.$utils.authCore.getEmailDomain(this.email)} via LDAP. A redefinição de senha deve ser feita pelo administrador do domínio`;
    },

    closeAlert() {
      this.show.showAlert = false;
    },

    /**
     * FN TO RESET PASSWORD
     */
    resetPassword(event) {
      event.preventDefault();
      if (!this.email) {
        return this.$brain.swal({
          type: 'info',
          confirmButtonText: 'Ok, entendi',
          text: 'Ops, você precisa informar um email válido.',
        });
      }

      if (this.isLdapUser) {
        this.ldapMessage();
        this.show.showAlert = true;
        return;
      }

      if ((!this.hasExternalAuth) && (!this.name)) {
        this.resetPasswordSuccess();
        return;
      }

      this.call.run(
        this.$utils.authCore.requestNewPassword(this.email),
        this.resetPasswordSuccess,
        this.resetPasswordFail,
      );
    },
    resetPasswordSuccess(res) {
      this.returnToCheckEmail();
      this.$brain.swal({
        type: 'success',
        confirmButtonText: 'Ok, entendi',
        html: `
					<h3>Pedido enviado!</h3>
					<p>Verifique seu email para continuar.</p>
				`,
        onClose: () => {
          this.emailInputFocus();
        },
      });
    },
    resetPasswordFail(err) {
      if (err.status == 401) {
        this.$brain.swal({
          type: 'warning',
          confirmButtonText: 'Ok, entendi',
          html: `
						<h3>Algum imprevisto aconteceu!</h3>
						<p>Já entramos em contato com o suporte informando o problema ocorrido, mas você pode tentar novamente mais tarde.</p>
					`,
          onClose: () => {
            this.emailInputFocus();
          },
        });
      } else {
        return this.$brain.connectionError({
          code: 'resetPasswordFail',
          data: {
            email: this.email,
          },
          stack: _.get(err, 'stack') || _.get(err, 'message') || err,
        });
      }
    },

    createNewUser() {
      this.call.run(
        this.$utils.authCore.createUser(this.email),
        res => {
          this.$brain.swal({
            confirmButtonText: 'Concluir',
            html: `
            <img src="../../../static/modal-send-email.png" style="width: 100px; margin-bottom: 20px;">
						<h3 class="pb">E-mail enviado com sucesso!</h3>
						<p class="pb">Acesse o seu e-mail <span style="color: var(--color-primary)">${this.email}</span> e clique no link recebido para finalizar o seu cadastro.</p>
					`,
          });
          this.returnToCheckEmail();
        },
        err => {
          this.$brain.connectionError({
            code: 'createNewUserFail',
            data: {
              email: this.email,
            },
            stack: _.get(err, 'stack') || _.get(err, 'message') || err,
          });
          this.returnToCheckEmail();
        },
      );
    },
    returnToCheckEmail() {
      this.email = this.password = this.name = '';
      this.validatedEmail = false;
      this.emailInputFocus();
    },
    invalidPassword() {
      this.$brain.swal({
        type: 'info',
        confirmButtonText: 'Ok, entendi',
        html: `
					<h3>${(this.selfRegistration.enabled) ? 'Senha incorreta' : 'Usuário/Senha incorreta'}</h3>
					<p>Tente novamente.</p>
				`,
        onClose: () => {
          this.password = '';
        },
      });
    },
    invalidEmail() {
      this.$brain.swal({
        type: 'info',
        confirmButtonText: 'Ok, entendi',
        html: `
					<h3>Usuário "${this.email}" inexistente!</h3>
					<p>Tente novamente.</p>
				`,
      });
    },
    invalidUsernameOrPassword(message) {
      console.log(message);
      this.$brain.swal({
        type: 'info',
        confirmButtonText: 'Ok, entendi',
        html: `
					<h3>${message}</h3>
					<p>Tente novamente.</p>
				`,
        onClose: () => {
          this.password = '';
          this.passwordInputFocus();
        },
      });
    },
    userBlocked() {
      let html;
      if (_.has(this.company.json, 'message.userBlocked')) { html = this.company.json.message.userBlocked; } else {
        html = `<h3><strong>Atenção!</strong></h3>
                         <p>Seu usuário está bloqueado.<br>Entre em contato para obter mais informações.</p>`;
      }

      this.$brain.swal({
        type: 'warning',
        confirmButtonText: 'Ok, entendi',
        html,
        onClose: () => {
          this.emailInputFocus();
        },
      });
    },
    getSelfRegistration() {
      this.selfRegistration.enabled = _.get(this.company.json, 'selfRegistration.enabled');

      this.selfRegistration.enableUserNotRegisteredNotification = _.get(this.company.json, 'selfRegistration.enableUserNotRegisteredNotification') || false;
    },
    getMessage() {
      if (_.has(this.company, 'json.message.login.html'))
        this.messageHtml = this.company.json.message.login.html;
    },
    openModalLogin() {
      if (
        _.has(this.company, 'json.modalLogin.html')
        && $(window).width() > '768'
      ) {
        const content = this.$cookies.get('watched');
        if (
          !this.$cookies.get('watched')
          || this.company.json.modalLogin.html != content
        ) {
          setTimeout(() => {
            $('.proModalLogin').modal('show');
            if (!this.company.json.modalLogin.setCookieWatched) return;
            this.$cookies.set('watched', this.company.json.modalLogin.html);
          }, 100);
          // $('.proModalLogin').modal('show');
        }
      }
    },
    emailInputFocus() {
      setTimeout(() => $('input[type=email]').focus());
    },
    passwordInputFocus() {
      setTimeout(() => $('input[type=password]').focus());
    },
  },
};
</script>

<style scoped lang="scss">
.box-login h3 {
  width: 216px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.container-500 {
  max-width: 500px !important;
  width: 90%;
  height: auto;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.box-login {
  .reset-password {
    display: inline-block;
    p {
      margin-top: 0px !important;
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
</style>
